import { render, staticRenderFns } from "./AccountPlan.vue?vue&type=template&id=ec370dc0"
import script from "./AccountPlan.vue?vue&type=script&lang=js"
export * from "./AccountPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports